import React, { FC } from 'react';

import {
  SimMetricsGroupsPie,
  SimUsageLineGraph,
  Typography,
} from '@components';

type Props = {
  phoneNumbers?: string[];
};

export const Graphs = ({ phoneNumbers }: Props) => {
  return (
    <div className="grid grid-cols-5 gap-4 mt-5">
      <div className="col-span-5 lg:col-span-3">
        <Typography tag="h2" type="subtitle">
          Algemeen verbruik
        </Typography>
        <div className="mb-5"></div>
        <SimUsageLineGraph phoneNumbers={phoneNumbers} />
      </div>

      <div className="col-span-5 lg:col-span-2 w-full justify-center items-start">
        <Typography tag="h2" type="subtitle">
          Verbruik detail per maand
        </Typography>
        <div className="mb-5"></div>
        <SimMetricsGroupsPie phoneNumbers={phoneNumbers} />
      </div>
    </div>
  );
};

export const SimGraphs: FC<{ phoneNumbers?: string[] }> = ({
  phoneNumbers,
}) => {
  return <Graphs phoneNumbers={phoneNumbers} />;
};

export default SimGraphs;
